(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-archieve"] && !Shopify.designMode) return;
  try {
    
/* bf-ladezeit 18.10.: jQuery lädt jetzt mit defer (layout/theme.liquid). Dieser Block wartet, bis jQuery da ist.
   Rückbau: die Zeile mit bfMagazinFilter und die drei Schlusszeilen vor endjavascript entfernen. */
(function () { function bfMagazinFilter() {
   let option_val = document.querySelectorAll('.blog_type a');
    option_val.forEach((e) => {
       
      e.addEventListener('click', (e1) => {
         let option_val = e.getAttribute('data_v12');
        
        var blen = $('.blog-articles__article').length;
         $('.blog-articles__article').removeClass("active");
        for (i=0; i< blen; i++){
          
          if(option_val == "GGs Magazin"){
           document.getElementsByClassName('blog-articles__article')[i].classList.add("active");
            document.getElementsByClassName('blog-articles__article')[i].classList.remove("reactive");
          }else if(document.getElementsByClassName('blog-articles__article')[i].getAttribute('data_v1').includes(option_val)){
           document.getElementsByClassName('blog-articles__article')[i].classList.add("active");
            document.getElementsByClassName('blog-articles__article')[i].classList.remove("reactive");
          }else{
            document.getElementsByClassName('blog-articles__article')[i].classList.add("reactive");
          }
        }
         // let span = document.querySelector(".blog_t1");
         // span.setAttribute("dat_v1", option_val);
         // let option_val1 = document.querySelector('.blog_t1');
         // let dat_v1 = option_val1.getAttribute('dat_v1');
         // let book1 = document.getElementsByClassName("article_dis");
         //    Array.from(book1).forEach(element => {
         //       let data1 = element.getAttribute('data_v1');
         //         if(dat_v1 == 'GGs Magazin'){
         //       element.classList.add("active"); 
         //       element.classList.remove("reactive");
         //    }
         //       else if(data1 == dat_v1){ 
         //          element.classList.add("active");  
         //          element.classList.remove("reactive");
         //        }
         //      else{ 
         //        element.classList.add("reactive");
         //         element.classList.remove("active"); 
         //      }  
         //    });
        });
    });
 var nm = $('#page_hd_nm').val(); 
  $( ".cat_links a" ).each(function( index ) {
    if($( this ).text().trim() == nm){
    $(".cat_links a").removeClass("link-active");
    $( this ).addClass("link-active");
  } 
});

$( ".cat_links a" ).click(function() {
  $( ".cat_links a" ).removeClass("link-active");
   $(this).addClass("link-active");
  if($('.link-active').attr("data-handel") == 'ggs-magazin'){
    $('.val1').removeClass('active');
    $('.val1').removeClass('reactive');
  }
   var currentUrl = $(location).attr('href');
var url = new URL(currentUrl);
  var queryval=$(this).attr("query-str");
url.searchParams.set("blog", queryval); // setting your param
var newUrl = url.href; 
history.pushState(null, null,newUrl);
});

 var myaatr=$("ul.blog-menu").attr('data-query');
  
     if ( myaatr != '') {
       
       $("ul.blog-menu li").each(function(){
        var str1 = $(this).find("a").attr("data-handel");
var str2 = $("ul.blog-menu").attr('data-query');
if(str1.indexOf(str2) != -1){
 
    $(this).find("a").click();
 let option_val = $(this).find("a").attr('data_v12');
        
        var blen = $('.blog-articles__article').length;
         $('.blog-articles__article').removeClass("active");
        for (i=0; i< blen; i++){
          
          if(option_val == "GGs Magazin"){
           document.getElementsByClassName('blog-articles__article')[i].classList.add("active");
            document.getElementsByClassName('blog-articles__article')[i].classList.remove("reactive");
          }else if(document.getElementsByClassName('blog-articles__article')[i].getAttribute('data_v1').includes(option_val)){
           document.getElementsByClassName('blog-articles__article')[i].classList.add("active");
            document.getElementsByClassName('blog-articles__article')[i].classList.remove("reactive");
          }else{
            document.getElementsByClassName('blog-articles__article')[i].classList.add("reactive");
          }
        }
}
         });
     }
} /* Ende bfMagazinFilter (bf-ladezeit 18.10.) */
if (window.jQuery) bfMagazinFilter();
else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bfMagazinFilter);
else window.addEventListener('load', bfMagazinFilter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('hidden-s', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
